export interface IUserPasswordChangePageData {
    culture: string;
    companyId: string;
    companyName: string;
    companyLogo: string;
    minPasswordLength: number;
    isInvitation: boolean;
}

export class UserPasswordChangePageData implements IUserPasswordChangePageData {
    culture: string;
    companyId: string;
    companyName: string;
    companyLogo: string;
    minPasswordLength: number;
    isInvitation: boolean;

    constructor();
    constructor(obj: IUserPasswordChangePageData);
    constructor(obj?: any) {
        this.culture = obj && obj.culture || "";
        this.companyId = obj && obj.companyId || "";
        this.companyName = obj && obj.companyName || "";
        this.companyLogo = obj && obj.companyLogo || "";
        this.minPasswordLength = obj && obj.minPasswordLength || 0;
        this.isInvitation = obj && obj.isInvitation || false;
    }
}